/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Bell_Open_UnreadInputs */

const en_bell_open_unread = /** @type {(inputs: Bell_Open_UnreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notifications, ${i?.count} unread`)
};

/**
* | output |
* | --- |
* | "Notifications, {count} unread" |
*
* @param {Bell_Open_UnreadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_open_unread = /** @type {((inputs: Bell_Open_UnreadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Open_UnreadInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_open_unread(inputs)
});